import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function LoginSection() {
  const [tab, setTab] = useState<'login' | 'register'>('login');
  const [showPassword, setShowPassword] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const body = new URLSearchParams();
    data.forEach((value, key) => body.append(key, value.toString()));

    await fetch('https://readdy.ai/api/form/d7d5p2skpdh0a4advrog', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });
    setSubmitted(true);
  };

  return (
    <section id="login" className="py-20 bg-gradient-to-br from-rose-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Info */}
        <div className="flex-1 text-center lg:text-left">
          <div className="inline-flex items-center gap-2 bg-red-100 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-user-heart-line text-red-500 text-sm"></i>
            <span className="text-xs font-semibold text-red-600">会员登录入口</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" style={{ fontFamily: "'Noto Serif SC', serif" }}>
            加入富缘佳旺<br />
            <span className="text-red-600">开启缘分之旅</span>
          </h2>
          <p className="text-gray-500 text-base mb-8 max-w-md mx-auto lg:mx-0">
            注册成为会员，享受视频认证、学历优先匹配、专业情感指导等专属服务。
          </p>
          <div className="grid grid-cols-2 gap-4 max-w-sm mx-auto lg:mx-0">
            {[
              { icon: 'ri-video-chat-line', label: '视频通话', desc: '实时视频验证真实身份' },
              { icon: 'ri-graduation-cap-line', label: '学历优先', desc: '教育背景匹配系统' },
              { icon: 'ri-shield-user-line', label: '安全认证', desc: '身份证实名认证' },
              { icon: 'ri-heart-3-line', label: '精准匹配', desc: '智能算法推荐缘分' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-4 flex items-start gap-3 shadow-sm">
                <div className="w-9 h-9 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-red-500`}></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-800">{item.label}</div>
                  <div className="text-xs text-gray-400 mt-0.5">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Login Form */}
        <div className="w-full lg:w-[420px] bg-white rounded-2xl shadow-lg overflow-hidden">
          {/* Tab */}
          <div className="flex border-b border-gray-100">
            {(['login', 'register'] as const).map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`flex-1 py-4 text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${tab === t ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-400 hover:text-gray-600'}`}
              >
                {t === 'login' ? '会员登录' : '免费注册'}
              </button>
            ))}
          </div>

          <div className="p-6">
            {submitted ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-green-500 text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2">提交成功！</h3>
                <p className="text-gray-500 text-sm">我们将尽快与您联系，开启您的缘分之旅。</p>
                <button onClick={() => setSubmitted(false)} className="mt-4 text-red-500 text-sm cursor-pointer">返回</button>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <input type="hidden" name="form_type" value={tab === 'login' ? '会员登录' : '免费注册'} />

                {tab === 'register' && (
                  <div>
                    <label className="text-xs text-gray-500 font-medium mb-1.5 block">昵称</label>
                    <input
                      name="nickname"
                      type="text"
                      placeholder="请输入您的昵称"
                      className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-red-400"
                    />
                  </div>
                )}

                <div>
                  <label className="text-xs text-gray-500 font-medium mb-1.5 block">手机号 / 邮箱</label>
                  <input
                    name="email"
                    type="email"
                    placeholder="请输入手机号或邮箱"
                    required
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-red-400"
                  />
                </div>

                <div>
                  <label className="text-xs text-gray-500 font-medium mb-1.5 block">密码</label>
                  <div className="relative">
                    <input
                      name="password"
                      type={showPassword ? 'text' : 'password'}
                      placeholder="请输入密码"
                      required
                      className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-red-400 pr-10"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer"
                    >
                      <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                    </button>
                  </div>
                </div>

                {tab === 'register' && (
                  <div>
                    <label className="text-xs text-gray-500 font-medium mb-1.5 block">最高学历</label>
                    <select name="education" className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-red-400 cursor-pointer">
                      <option value="">请选择学历</option>
                      <option value="phd">博士</option>
                      <option value="master">硕士</option>
                      <option value="bachelor">本科</option>
                      <option value="college">大专</option>
                    </select>
                  </div>
                )}

                <Link
                  to="/auth"
                  className="w-full bg-gradient-to-r from-red-600 to-red-700 text-white py-3 rounded-full font-semibold text-sm hover:from-red-700 hover:to-red-800 transition-all cursor-pointer whitespace-nowrap mt-1 text-center block"
                >
                  {tab === 'login' ? '立即登录' : '免费注册'}
                </Link>

                <div className="flex items-center gap-3 my-1">
                  <div className="flex-1 h-px bg-gray-100"></div>
                  <span className="text-xs text-gray-400">或使用</span>
                  <div className="flex-1 h-px bg-gray-100"></div>
                </div>

                <div className="flex gap-3">
                  <button type="button" className="flex-1 flex items-center justify-center gap-2 border border-gray-200 rounded-lg py-2.5 text-sm text-gray-600 hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                    <i className="ri-wechat-line text-green-500"></i> 微信
                  </button>
                  <button type="button" className="flex-1 flex items-center justify-center gap-2 border border-gray-200 rounded-lg py-2.5 text-sm text-gray-600 hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                    <i className="ri-weibo-line text-red-400"></i> 微博
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
